import { render, staticRenderFns } from "./inbound-fax-completed-icon.vue?vue&type=template&id=55e97c88"
import script from "./inbound-fax-completed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-fax-completed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports